export interface singleExercise {
    "id": string,
    "title_new": string,
    "Instructor_gender": string,
    level: string,
    "exercise_type-1": string,
    "exercise_type-2": string,
    "exercise_type-3": string,
    equipment_name: string,
    equipment_category_1: string,
    "MG1": string,
    "MG2"?: string,
    "MG3"?: string,
    "MG4"?: string,
    "mp4": string,
    "en_step-1": string,
    "en_step-2": string,
    "en_step-3": string,
    "en_step-4": string,
    "category": string
}

export interface listPageItem {
    name: string;
    thumbnail: string;
    id: string;
    search: string[];
    type: string;
    difficulty?: Difficulty;
    category: string
}

export enum Difficulty {
    BEGINNER = 'Beginner',
    INTERMEDIATE = 'Intermediate',
    ADVANCED = 'Advanced'
}